import React from 'react';

interface ChangeItemProps {
  label: string;
  oldValue: string | number | undefined;
  newValue: string | number | undefined;
  wordBreak?: boolean;
}

export const ChangeItem: React.FC<ChangeItemProps> = ({ label, oldValue, newValue, wordBreak = false }) => {
  return (
    <li className="mb-2 p-2" style={{ backgroundColor: '#fff3cd', borderRadius: '4px', border: '1px solid #ffc107' }}>
      <strong>🔄 {label}:</strong>
      <div className="ms-3 mt-1">
        <span
          className="text-decoration-line-through text-muted"
          style={wordBreak ? { wordBreak: 'break-all' } : undefined}
        >
          {oldValue || '(empty)'}
        </span>
        {' → '}
        <span className="fw-bold" style={{ color: '#dc3545', ...(wordBreak ? { wordBreak: 'break-all' } : {}) }}>
          {newValue || '(empty)'}
        </span>
      </div>
    </li>
  );
};
